import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";


import { Box, Typography } from "@mui/material";
import {useEffect, useState} from "react";

function CustomNoRowsOverlay() {
  return (
      <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
      >
        <Typography variant="body1">No data available</Typography>
      </Box>
  );
}

export default function AppTableView(props) {
  const {
    rows,
    cols,
    hasRowSelectableFn = () => false ,
    handleRowSelection = () => null,
    checkboxSelection = false,
    initialPageSize = 15,
    rowHeight,
    idKey = "id",
    setPaginationModel = () => null,
    setSortModel = () => null,
    totalElements,
    paramsData = {},
    paginationMode = "client", // Default to "client" if not provided,
    sortMode = "client",
  } = props || {};

  const paginationData = {
    page:0,
    pageSize: initialPageSize,
    ...paramsData
  }

  const totalElementsCount = totalElements || rows?.length; // Ensure totalElements is defined

  return (
    <DataGrid
      paginationMode={paginationMode}
      sortingMode={sortMode}
      resizeThrottleMs={400}
      {...(paginationMode === "server" && {
        paginationModel: paginationData,
        onPaginationModelChange: setPaginationModel,
        rowCount: totalElementsCount,
      })}
      {...(sortMode === "server" && {
        onSortModelChange:setSortModel,
        sortModel: paramsData.sortParams || [],
      })}
      checkboxSelection={checkboxSelection}
      rows={rows}
      onRowSelectionModelChange={(ids) => handleRowSelection(ids)}
      isRowSelectable={({ row }) => hasRowSelectableFn(row)}
      columns={cols}
      getRowId={(row) => row[idKey]}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
      }
      initialState={{
        pagination: { paginationModel: { pageSize: initialPageSize } },
      }}
      pageSizeOptions={[15, 50, 75, 100]}
      disableColumnResize
      density="compact"
      disableColumnFilter
      slots={{
        noRowsOverlay: CustomNoRowsOverlay,
        noResultsOverlay: CustomNoRowsOverlay,
      }}
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: "outlined",
              size: "small",
            },
            columnInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            operatorInputProps: {
              variant: "outlined",
              size: "small",
              sx: { mt: "auto" },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: "outlined",
                size: "small",
              },
            },
          },
        },
        pagination: {
          slotProps: {
            selectLabel: {
              sx: {
                mb: "0px",
              },
            },
            displayedRows: {
              sx: {
                mb: "0px",
              },
            },
          },
        },
      }}
      rowHeight={rowHeight}
      columnHeaderHeight={rowHeight}
      sx={{
        height: rows?.length > 0 ? "auto" : 200, // Adjust height dynamically
        minHeight: 200, // Minimum height for the table for no data, no data message occupying more height so limit added
      }}
    />
  );
}

AppTableView.propTypes = {
  rows: PropTypes.array.isRequired,
  cols: PropTypes.array.isRequired,
  hasRowSelectableFn: PropTypes.func,
  handleRowSelection: PropTypes.func,
  checkboxSelection: PropTypes.bool,
  initialPageSize: PropTypes.number,
  idKey: PropTypes.string,
};
